import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import Sidebar from '@/components/common/Sidebar/Sidebar.vue'
import ProgressRing from '@/components/common/ProgressRing.vue'
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
@Component({ 
    components: { Sidebar, ProgressRing },
    computed: {
        ...mapGetters({
            isLoading: types.GLOBAL_BUSY
        }),
    },
})
export default class PageLayout extends Vue {

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    isLoading!: boolean;
}